<template>
    <div>
        <modal v-if="showModal" :type="modalType" :data="selectedActivity" @close="closeModal" />

        <h2>Aktiviteter<div class="object-counter" v-if="activities.length > 0" :title="`${activities.length} aktivitet${activities.length > 1 ? 'er' : ''} tilknyttet skabelonen`">{{ activities.length }}</div></h2>

        <div v-if="!activities || activities.length === 0" class="cell large-3">
            <p><em>Der er ingen aktiviteter tilknyttet skabelonen</em></p>
        </div>

        <div class="grid-x accordion-counter align-items">
            <div class="cell flexbox-end">
                <button v-if="activities && activities.length > 0" style="margin-right: 18px" class="button-blue" @click="removeActivity()" :disabled="!isAccordionSelected">
                    <icon class="bin-svg small-svg fill-dark-gray" name="bin" />
                    Slet
                </button>
                <button v-if="activities && activities.length > 0" class="button button-simplified arrows" @click="moveUp()" :class="{'disabled': !canMoveUp}" title="Flyt op">
                    <icon class="bin-svg small-svg fill-dark-gray" name="up-arrow" />
                </button>
                <button  v-if="activities && activities.length > 0"" class="button button-simplified arrows" @click="moveDown()" :class="{'disabled': !canMoveDown}" title="Flyt ned">
                    <icon class="bin-svg small-svg fill-dark-gray" name="down-arrow" />
                </button>
            </div>
        </div>
        <!-- ------------- Header ------------- -->
        <transition-group name="list" v-if="activities && activities.length > 0">
            <div class="accordion-item" v-for="(activity, index) in filteredListActivities" :key="`activity-${activity.activityId ? activity.activityId : activity.activityTypeId + '-' + index}`">
                <div class="grid-x align-items flexbox-nowrap">
                    <div class="auto cell accordion-container">
                        <div class="grid-x accordion row align-items" @click="select(activity)" :class="{'selected': activity.selected}" style="justify-content: space-between;">
                            <div class="cell icon-cell item flexbox-align-items">
                                <icon class="task-send-svg medium-svg fill-dark-gray" name="task-send" />
                            </div>
                            <div class="large-4 cell item">
                                <span class="activity-name">{{activity.activityType}}</span>
                            </div>
                            <div v-if="activity.sentToUser" class="large-4 cell truncate-fade item">
                                <span>{{activity.sentToUser}}</span>
                                <span>{{activity.sentToOrganization}}</span>
                            </div>
                            <div v-else class="cell large-4 item truncate-fade flexbox-align-items">
                                <span>Ingen entreprenør</span>
                            </div>
                            <div class="large-1 cell item flexbox-center" :title="(activity.description ? 'Bemærkning: ' + activity.description + '\n' : '') + (activity.reference ? 'Reference: ' + activity.reference : '')">
                                <icon v-if="activity.reference" class="dollar-svg small-svg fill-dark-gray" name="dollar"/>
                                <icon v-if="activity.description" class="bubble-svg small-svg fill-dark-gray" name="bubble" />
                            </div>
                            <a class="flexbox-center accordion-edit" title="Rediger aktivitet" @click="openModal('template-modal-activity', activity)">
                                <icon class="medium-svg fill-dark-gray" name="pencil" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>

        <button class="new-accordion" @click="openModal('template-modal-activity')" >Tilføj aktivitet</button>
        <button class="new-accordion" :disabled="!getActiveTaskId" @click="openModal('task-modal-activity-template')">Tilføj aktiviteter fra skabelon</button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import modal from './../../shared/modal/modal.vue'

export default {
    props: {
        onObjectChange: {
            type: Function
        },
        resetSelection: {
            type: Function
        },
        zoomLimit: false,
        deleteObject: {
            type: Function
        }
    },
    components: {
        modal
    },
    data () {
        return {
            showModal: false,
            modalType: null,
            selectedActivity: '',
            isAccordionSelected: false,
            allowRoutine: false,
            closedActivities: false
        }
    },
    computed: {
        ...mapGetters({
            activities: 'activitiesAndObjectsListTemplate',
            getActiveTaskId: 'getActiveTaskId',
            selectedActivities: 'getSelectedActivities'
        }),

        filteredListActivities () {
            if (!this.closedActivities) {
                return this.sortActivities([...this.activities].filter(l => !l.reportApproveDate))
            } else {
                return this.sortActivities([...this.activities])
            }
        },
        canMoveUp () {
            const selectedActivities = this.selectedActivities.filter(a => a.selected)
            return selectedActivities.length === 1 && selectedActivities[0] !== this.selectedActivities[0]
        },
        canMoveDown () {
            const selectedActivities = this.selectedActivities.filter(a => a.selected)
            return selectedActivities.length === 1 && selectedActivities[selectedActivities.length - 1] !== this.selectedActivities[this.selectedActivities.length - 1]
        }
    },
    watch: {
        activities: {
            handler () {
            },
            deep: true
        }
    },
    methods: {
        ...mapActions({
            saveActivityTemplate: 'createUpdateActivityTemplate',
            setSelectedActivities: 'setSelectedActivities',
            deleteActivities: 'deleteTemplateActivities'
        }),

        select (activity) {
            activity.selected = !activity.selected
            this.isAccordionSelected = false
            if (!activity.selected) {
                const found = this.selectedActivities.find(a => a.selected)
                if (found) {
                    this.isAccordionSelected = true
                }
            } else {
                this.isAccordionSelected = true
            }

            this.setSelectedActivities(activity)
                .then(() => {
                    for (let i in this.selectedActivities) {
                        if (this.selectedActivities[i].selected && !this.selectedActivities[i].routineIntervalTypeId) {
                            this.allowRoutine = false
                            break
                        } else {
                            this.allowRoutine = true
                        }
                    }
                    if (!this.isAccordionSelected) {
                        this.onObjectChange()
                    } else if (this.onObjectChange) {
                        this.onObjectChange(this.selectedActivities)
                    }
                })
        },
        openModal (type, data) {
            if (type === 'template-modal-activity' || this.selectedActivities !== false) {
                let show = true
                let noObjects = []
                for (let i = 0; i < this.selectedActivities.length; i++) {
                    if (this.selectedActivities[i].selected) {
                        if (this.selectedActivities[i].objectList && this.selectedActivities[i].objectList.length > 0) {
                            if (this.selectedActivities[i].objectList.filter(object => object.deleting).length === this.selectedActivities[i].objectList.length) {
                                noObjects.push(this.selectedActivities[i])
                            }
                        } else {
                            noObjects.push(this.selectedActivities[i])
                        }
                    }
                }
                if (show) {
                    this.showModal = true
                    this.modalType = type
                    this.selectedActivity = data
                }
            }
        },
        closeModal () {
            this.showModal = false
        },
        removeActivity () {
            const activityList = this.selectedActivities.filter(activity => activity.selected).map((activity, index) => {
                const activityObject = { ...activity }

                if (!activityObject.activityId) {
                    activityObject.generatedActivityId = `${activity.activityTypeId}_${index}`
                    if (activity.sentToOrganizationId && activity.sentToUserId) {
                        activityObject.generatedActivityId += `_${activity.sentToOrganizationId}_${activity.sentToUserId}`
                    } else if (activity.sentToOrganizationId) {
                        activityObject.generatedActivityId += `_${activity.sentToOrganizationId}`
                    }
                }

                return activityObject
            })

            const payload = {
                'templateId': this.getActiveTaskId ? this.getActiveTaskId : null,
                'activityList': activityList
            }

            this.deleteActivities(payload)
                .then(() => {
                    this.isAccordionSelected = false
                    if (this.onObjectChange) {
                        this.onObjectChange(this.selectedActivities)
                    }
                })
        },
        moveUp () {
            const idx = this.selectedActivities.findIndex(a => a.selected)
            const current = this.selectedActivities[idx]
            this.$set(this.selectedActivities, idx, this.selectedActivities[idx - 1])
            this.$set(this.selectedActivities, idx - 1, current)
        },
        moveDown () {
            const idx = this.selectedActivities.findIndex(a => a.selected)
            const current = this.selectedActivities[idx]
            this.$set(this.selectedActivities, idx, this.selectedActivities[idx + 1])
            this.$set(this.selectedActivities, idx + 1, current)
        },

        sortActivities (list) {
            // Sort list first by `startDate` or `latestDate` in that priority
            return list.sort((a, b) => {
                if (a && a.startDate === null && a.latestDate && b && b.startDate) {
                    const aLatestDate = new Date(a.latestDate)
                    const bStartDate = new Date(b.startDate)

                    return aLatestDate - bStartDate
                } else if (a && a.latestDate === null && a.startDate && b && b.latestDate) {
                    const aStartDate = new Date(a.startDate)
                    const bLatestDate = new Date(b.latestDate)

                    return aStartDate - bLatestDate
                } else if (a && a.latestDate && b && b.latestDate) {
                    const aLatestDate = new Date(a.latestDate)
                    const bLatestDate = new Date(b.latestDate)

                    return aLatestDate - bLatestDate
                } else if (a && a.startDate && b && b.startDate) {
                    const aStartDate = new Date(a.startDate)
                    const bStartDate = new Date(b.startDate)

                    return aStartDate - bStartDate
                } else {
                    return -1
                }
            }).reverse()
        }
    }
}
</script>

<style lang="scss" scoped>
.checkbox-end {
    margin-right: 10px;
    margin-top: 0px;
}

.arrows {
    width: 40px;

    svg {
        margin-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/taskTemplate/taskTemplate-activities.vue